import type { FormikErrors } from 'formik';
import type { TFunction } from 'i18next';

import type { ResetPasswordData, ResetPasswordDataPending, ResetPasswordFormValues } from './types';

const resetPasswordInitialValues: ResetPasswordFormValues = {
  password: '',
  password_confirmation: ''
};

const resetPasswordValidate = (
  { password, password_confirmation }: ResetPasswordFormValues,
  t: TFunction
) => {
  const errors: FormikErrors<ResetPasswordFormValues> = {};
  if (password.length === 0) {
    errors.password = t('signup-password_required');
  }

  if (password.length < 8) {
    errors.password = t('signup-password_length');
  }

  if (password_confirmation.length === 0) {
    errors.password_confirmation = t('signup-password_confirmation_required');
  } else if (password !== password_confirmation) {
    errors.password_confirmation = t('signup-password_confirmation_no_match');
  }
  return errors;
};

const isPendingResetPassword = (data: ResetPasswordData): data is ResetPasswordDataPending =>
  'status' in data && data.status === 'reset_password_pending';

export { resetPasswordInitialValues, resetPasswordValidate, isPendingResetPassword };
